/* ============================================
   FLORENZ.LA — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* --- Mobile Nav --- */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => mobileNav.classList.add('open'));
    mobileClose?.addEventListener('click', () => mobileNav.classList.remove('open'));
  }

  /* --- Cart Drawer --- */
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer  = document.querySelector('.cart-drawer');
  const cartTriggers = document.querySelectorAll('[data-cart-open]');
  const cartClose    = document.querySelector('[data-cart-close]');

  function openCart() {
    cartOverlay?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartOverlay?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  /* --- Gallery Thumbnails (Product Page) --- */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.gallery-main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.querySelector('img')?.src;
    });
  });

  /* --- Add to Cart (AJAX) --- */
  const addToCartForm = document.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = addToCartForm.querySelector('.add-to-cart');
      const formData = new FormData(addToCartForm);

      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });
        if (res.ok) {
          await updateCartCount();
          openCart();
          await renderCartItems();
        }
      } catch(err) {
        console.error('Add to cart error:', err);
      } finally {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }
    });
  }

  /* --- Cart Helpers --- */
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch(e) {}
  }

  async function renderCartItems() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const container = document.querySelector('.cart-items');
      if (!container) return;

      if (cart.items.length === 0) {
        container.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        return;
      }

      container.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img src="${item.featured_image?.url || item.image}" alt="${item.title}">
          <div class="cart-item__body">
            <div class="cart-item__title">${item.product_title}</div>
            <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="cart-item__price">${formatMoney(item.price)} × ${item.quantity}</div>
          </div>
          <button class="cart-item__remove" data-key="${item.key}">✕</button>
        </div>
      `).join('');

      const subtotal = document.querySelector('.cart-subtotal-amount');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      container.querySelectorAll('.cart-item__remove').forEach(btn => {
        btn.addEventListener('click', async () => {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }),
          });
          await updateCartCount();
          await renderCartItems();
        });
      });
    } catch(e) {}
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  updateCartCount();
  renderCartItems();

  /* --- Quick Add --- */
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        await updateCartCount();
        openCart();
        await renderCartItems();
      } catch(e) {}
      btn.textContent = 'Quick Add';
    });
  });

  /* --- Option Pills --- */
  document.querySelectorAll('.option-pills').forEach(group => {
    group.querySelectorAll('.option-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.option-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
      });
    });
  });

  /* --- Scroll Reveal --- */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => io.observe(el));
  }

});
